'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxSimple = require('redux-simple');

var _projectsActions = require('actions/projectsActions');

var _userActions = require('actions/userActions');

var _Auth = require('components/Auth');

var _Projects = require('components/Projects');

var _User = require('components/User');

var _Icons = require('components/Common/Icons');

var _Auth2 = require('../../components/Auth');

var _Common = require('components/Common');

var _routing = require('../../constants/routing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./UserPage.pcss');

var getState = function getState(state) {
  return {
    routeType: state.routing.type,
    authorizedUser: state.user.authorizedUser,
    shownUser: state.user.shownUser,
    projects: state.projects.list
  };
};

var UserPage = (_dec = (0, _reduxSimple.connect)(getState, { addProject: _projectsActions.addProject, logInAndToIndex: _userActions.logInAndToIndex }), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(UserPage, _Component);

  function UserPage() {
    _classCallCheck(this, UserPage);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(UserPage).apply(this, arguments));
  }

  _createClass(UserPage, [{
    key: 'isProjectListEmpty',
    value: function isProjectListEmpty() {
      var projects = this.props.projects;

      if (!projects) return false;
      if (projects.length === 0) return true;
      return false;
    }
  }, {
    key: 'isUserForeign',
    value: function isUserForeign() {
      var _props = this.props;
      var shownUser = _props.shownUser;
      var authorizedUser = _props.authorizedUser;


      if (!authorizedUser) return true;
      if (!shownUser) return false;

      return shownUser.id !== authorizedUser.id;
    }
  }, {
    key: 'getEmptyProjectListCaption',
    value: function getEmptyProjectListCaption() {
      var shownUser = this.props.shownUser;


      if (this.isUserForeign()) {
        var userName = shownUser.displayName;

        return _react2.default.createElement(
          'div',
          null,
          userName,
          ' has no projects to show yet.',
          _react2.default.createElement('br', null),
          'How about making your own project with Meta?',
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { className: styles.startNewProject },
            _react2.default.createElement(_Common.StartNewProjectButton, null)
          )
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        'You\'ve just deleted your last project. ',
        _react2.default.createElement('br', null),
        'Click the button above to create a new one.'
      );
    }
  }, {
    key: 'getProjectsList',
    value: function getProjectsList() {
      var projects = this.props.projects;


      if (this.isProjectListEmpty()) {
        return _react2.default.createElement(
          'div',
          { className: styles.emptyProjectsListCaption },
          this.getEmptyProjectListCaption()
        );
      }

      return _react2.default.createElement(_Projects.ProjectsList, { projects: projects });
    }
  }, {
    key: 'isForeignProfile',
    value: function isForeignProfile() {
      var _props2 = this.props;
      var authorizedUser = _props2.authorizedUser;
      var shownUser = _props2.shownUser;
      var routeType = _props2.routeType;


      if (routeType === _routing.JALAN_INDEX) return false;
      if (!shownUser) return true;
      if (!authorizedUser) return true;

      return authorizedUser.id !== shownUser.id;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var authorizedUser = _props3.authorizedUser;
      var shownUser = _props3.shownUser;
      var routeType = _props3.routeType;

      /*
      if (!authorizedUser && !isForeignProfile) {
        return <Login />;
      }
      */

      if (routeType === _routing.JALAN_INDEX && !authorizedUser) {
        return _react2.default.createElement(_Auth.Login, null);
      }

      if (!(authorizedUser || shownUser)) {
        return _react2.default.createElement(_Common.Spinner, { routeSpinner: true });
      }

      var isForeignProfile = this.isForeignProfile();

      if (isForeignProfile && !shownUser) {
        return _react2.default.createElement(_Common.Spinner, { routeSpinner: true });
      }

      return _react2.default.createElement(
        _User.UserPageWrapper,
        null,
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'div',
            { className: styles.logoWrapper },
            isForeignProfile ? _react2.default.createElement(
              _Common.Link,
              { jalan: { type: _routing.JALAN_INDEX } },
              _react2.default.createElement(_Icons.Logo, { className: styles.logo, width: '69', height: '50' })
            ) : _react2.default.createElement(_Icons.Logo, { className: styles.logo, width: '69', height: '50' })
          ),
          authorizedUser && !isForeignProfile ? _react2.default.createElement(_Projects.ProjectAdd, null) : _react2.default.createElement(
            'div',
            { className: styles.otherUser },
            _react2.default.createElement(_User.UserPic, { url: shownUser.avatarUrl }),
            _react2.default.createElement(
              'div',
              { className: styles.userName },
              authorizedUser && authorizedUser.id === isForeignProfile ? shownUser.displayName + ' - public profile' : shownUser.displayName
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.right },
            authorizedUser ? _react2.default.createElement(_User.UserMenu, null) : _react2.default.createElement(_Auth2.LoginSmall, null)
          )
        ),
        this.getProjectsList()
      );
    }
  }]);

  return UserPage;
}(_react.Component), _class2.propTypes = {
  authorizedUser: _react.PropTypes.object,
  shownUser: _react.PropTypes.object,
  logInAndToIndex: _react.PropTypes.func
}, _temp)) || _class);
exports.default = UserPage;


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserPage.js
// module id = 228
// module chunks = 1